export const TAB_BAR_LIST = [
  {
    pagePath: 'pages/index/index',
    text: 'Home',
    icon: 'wap-home-o'
  },
  {
    pagePath: 'pages/task/orders',
    text: 'Tasks',
    icon: 'todo-list-o'
  },
  {
    pagePath: 'pages/income/index',
    text: 'Earnings introduction',
    icon: 'description'
  },
  {
    pagePath: 'pages/user/vip',
    text: 'VIP',
    icon: 'diamond-o'
  },
  {
    pagePath: 'pages/assets/assets',
    text: 'mine',
    icon: 'manager-o'
  }
]

export const TAB_BAR_PATHS = TAB_BAR_LIST.map(item => `/${item.pagePath}`)
